import { t } from "ttag";

import type { MedicationRequest } from "./types";

export const MEDICATION_REQUEST_STATUS = {
  PAID: "paid",
  PENDING: "pending",
  APPROVED: "approved",
  ON_ITS_WAY: "on its way",
  CANCELLED: "cancelled",
  DENIED: "denied",
  DELIVERY_UPDATE_REQUESTED: "delivery update requested",
  PROCESS_COMPLETE: "process complete",
  BRANDED_MEDICATION: "no more data",
  ARCHIVED: "archived",
} as const;

export const MEDICATION_REQUEST_STATUS_COLOR = {
  [MEDICATION_REQUEST_STATUS.PENDING]: "yellow",
  [MEDICATION_REQUEST_STATUS.PAID]: "light-primary",
  [MEDICATION_REQUEST_STATUS.APPROVED]: "light-primary",
  [MEDICATION_REQUEST_STATUS.ON_ITS_WAY]: "yellow",
  [MEDICATION_REQUEST_STATUS.CANCELLED]: "red",
  [MEDICATION_REQUEST_STATUS.PROCESS_COMPLETE]: "green",
  [MEDICATION_REQUEST_STATUS.DENIED]: "red",
  [MEDICATION_REQUEST_STATUS.DELIVERY_UPDATE_REQUESTED]: "light-secondary",
  [MEDICATION_REQUEST_STATUS.BRANDED_MEDICATION]: "light-secondary",
  [MEDICATION_REQUEST_STATUS.ARCHIVED]: "light-secondary",
} as const;

export const getMedicationRequestStatusLabel = (
  status: MedicationRequest["status"],
) => {
  return {
    [MEDICATION_REQUEST_STATUS.PENDING]: t`Pending`,
    [MEDICATION_REQUEST_STATUS.PAID]: t`Paid`,
    [MEDICATION_REQUEST_STATUS.APPROVED]: t`Approved`,
    [MEDICATION_REQUEST_STATUS.ON_ITS_WAY]: t`On its way`,
    [MEDICATION_REQUEST_STATUS.CANCELLED]: t`Canceled`,
    [MEDICATION_REQUEST_STATUS.PROCESS_COMPLETE]: t`Completed`,
    [MEDICATION_REQUEST_STATUS.DENIED]: t`Denied`,
    [MEDICATION_REQUEST_STATUS.DELIVERY_UPDATE_REQUESTED]: t`Checking status`,
    [MEDICATION_REQUEST_STATUS.BRANDED_MEDICATION]: t`Branded`,
    [MEDICATION_REQUEST_STATUS.ARCHIVED]: t`Archived`,
  }[status];
};
